import { render, staticRenderFns } from "./MapNavigationTabs.vue?vue&type=template&id=06c5bd55&"
import script from "./MapNavigationTabs.vue?vue&type=script&lang=js&"
export * from "./MapNavigationTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports